(ns app.front.view.group.admin.escrow.counter-config-editor
  (:require [app.front.entities :as entities]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.config.counter-config-editor :as counter-config-editor]
            [core.front.event :refer [<sub]]))

(defn editor [{:keys [tr group-id]}]
  (let [group (<sub [::entities/entity group-id])]
    [acommon/config-section
     (tr [:escrow/escrow-account-numbering])
     (tr [:escrow/escrow-account-id-instruction])
     ^{:key (str group-id "-" (:entity/version group) "-id-editor")}
     [:form
      [counter-config-editor/counter-config-editor
       {:tr                  tr
        :group-id            group-id
        :counter-config-type :counter-config.type/escrow-account}]]]))
